const _ = require('lodash');

const EMPTY_EXPRESSION = {};

const isFilter = maybeFilter => {
  if (!maybeFilter) return false;
  if (!maybeFilter.target) return false;
  if (!maybeFilter.operation) return false;
  return true;
};

const isFilterSet = maybeFilterSet => {
  if (!maybeFilterSet) return false; // This is kind of gross. We need a better way to indicate that something in a filter set
  // When operator OR filters might be empty

  if (!maybeFilterSet.operator && !maybeFilterSet.filters) return false;
  return true;
};

const compile = (expression, getTarget, getOperation, storeResource, resources) => {
  const filterToExpression = filter => {
    if (!filter) return filter;
    if (_.isEmpty(filter.args) && !_.isNumber(filter.args)) return undefined; // Collapse empty filters

    return `${getTarget(filter)} ${getOperation(filter)} ${storeResource(filter, resources)}`;
  };

  const convertExpression = currentExpression => {
    if (isFilter(currentExpression)) return filterToExpression(currentExpression);

    if (isFilterSet(currentExpression)) {
      if (!currentExpression.filters || !currentExpression.filters.length) return undefined;
      const convertedFilters = convertExpression(currentExpression.filters);
      return convertedFilters.length > 1 ? {
        [currentExpression.operator]: convertedFilters
      } : convertedFilters[0]; // Flatten single-expression sets
    } // Note: Preventing tail recursion is not super efficient


    if (_.isArray(currentExpression)) return currentExpression.map(convertExpression).filter(Boolean);
    if (_.isObject(currentExpression)) return _.mapValues(currentExpression, convertExpression);
    return currentExpression;
  };

  const compiledExpression = convertExpression(expression);
  if (!compiledExpression) return EMPTY_EXPRESSION;
  return {
    resources,
    expression: compiledExpression
  };
};

const filterSetToQueryFactory = ({
  getTarget,
  getOperation,
  storeResource
}) => filterSet => {
  if (!filterSet) return filterSet;
  const resources = {};
  return compile(filterSet, getTarget, getOperation, storeResource, resources);
};

const collectFilters = expression => {
  if (isFilter(expression)) return [expression];
  if (isFilterSet(expression)) return _.flatten(expression.filters.map(collectFilters));
  return [];
};

module.exports = {
  filterSetToQueryFactory,
  collectFilters
};